import React, { ReactNode } from 'react';
import { getClassNames } from 'utils';
import './OverviewPanel.css';

type OverviewPanelProps = {
    className?: string,
    children: ReactNode,
};

const OverviewPanel = ({
    className = '',
    children = null,
}: OverviewPanelProps) => (
    <dl className={getClassNames('overview-panel', className)}>
        {children}
    </dl>
);

export default OverviewPanel;
